export enum ProfileFileNames {
  INITIATION_FILE = "INITIATION_FILE",
  TERMINATION_FILE = "TERMINATION_FILE",
  PROFILE_IMAGE = "PROFILE_IMAGE",
  CURRICULUM = "CURRICULUM",
  MEDICAL_EXAM = "MEDICAL_EXAM",
  EPP = "EPP",
  DNI = "DNI",
  DRIVING_LICENCE = "DRIVING_LICENCE",
  PASSPORT = "PASSPORT",
  CUIL = "CUIL",
}
